import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { BsArrowUpRight } from 'react-icons/bs'
import Rating from '@mui/material/Rating'
import { Helmet } from 'react-helmet-async'
import AI from '../Image/AI.webp'
import ML from '../Image/ML.webp'
import WD from '../Image/WD.webp'
import DS from '../Image/DS.webp'
import Android_App from '../Image/Android_App.webp'
import Robotics from '../Image/Robotics.webp'
import Cyber_Security from '../Image/Cyber_Security.webp'
import Cloud_Computing from '../Image/Cloud_Computing.webp'
import Human_Resource from '../Image/Human_Resource.webp'
import Finance from '../Image/Finance.webp'
import Business_Analytics from '../Image/Business_Analytics.webp'
import AutoCAD from '../Image/AutoCAD.webp'
import Digital_Marketing from '../Image/Digital_Marketing.webp'
import GenerativeAI from '../Image/GenerativeAI.webp'
import VLSI from '../Image/VLSI.webp'
import IOT from '../Image/Internet_Of_Things.webp'
import Embedded_System from '../Image/Embedded_System.webp'
import UIUX from '../Image/uiux.webp'
import SM from '../Image/Stock_Market.webp'
import GD from '../Image/Graphic_Design.webp'
import ARVR from '../Component/image/AR_VR.jpg'
import Bioinformatic from '../Component/image/Bioinformatics.jpg'
import CD from '../Component/image/Cardesign.jpg'
import GE from '../Component/image/Genetic.jpg'
import HEV from '../Component/image/HEV.jpg'
import ICE from '../Component/image/IC_Engine.jpg'
import NSNT from '../Component/image/NSNT.jpg'
import Psy from '../Component/image/Psychology.jpg'
import RA from '../Component/image/RA.png'
import SCM from '../Component/image/SCM.jpg'

function Our_program() {
  const courses = [
     {
      title: 'Android App Development',
      description:
        'Embark on a dynamic journey into Android development with our comprehensive Training Internship...',
      imageUrl: Android_App,
      rating: 4,
      link: '/Android-App-Development',
      alt: 'Android-App-Development',
      rating: 4.5,
    },
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program...',
      imageUrl: AI,
      rating: 4,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
      rating: 4.5,
    },
    {
      title: 'AR/VR',
      description:
        'AR-VR blends real and virtual worlds to create immersive experiences for learning, gaming, and...',
      imageUrl: ARVR,
      rating: 4,
      link: '/AR-VR',
      alt: 'AR-VR',
      rating: 4.5,
    },
     {
      title: 'AutoCAD',
      description:
        'Learn AutoCAD from the ground up with our engaging course materials. Our training covers all the...',
      imageUrl: AutoCAD,
      rating: 4,
      link: '/Autocad',
      alt: 'AutoCAD',
      rating: 4.5,
    },
    {
      title: 'Bio informatic',
      description:
        'Bioinformatics integrates biology and technology to analyze complex biological data for discoveries and...',
      imageUrl: Bioinformatic,
      rating: 4,
      link: '/Bio-Informatics',
      alt: 'Bioinformatic',
      rating: 4.5,
    },
    {
      title: 'Business Analytics',
      description:
        'With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity...',
      imageUrl: Business_Analytics,
      rating: 4,
      link: '/Business-Analytics',
      alt: 'Business-Analytics',
      rating: 4.5,
    },
     {
      title: 'Car Design',
      description:
        'Car Design focuses on creating innovative, functional, and aesthetic vehicle concepts for future mobility and...',
      imageUrl: CD,
      rating: 4,
      link: '/Car-Design',
      alt: 'Car Design',
      rating: 4.5,
    },
     {
      title: 'Cloud Computing',
      description:
        'Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure...',
      imageUrl: Cloud_Computing,
      rating: 4,
      link: '/Cloud-Computing',
      alt: 'Cloud-Computing',
      rating: 4.5,
    },
    {
      title: 'Cyber Security',
      description:
        'With our in-depth course covering key ideas, network history, operating system fundamentals, and ethical...',
      imageUrl: Cyber_Security,
      rating: 4,
      link: '/Cyber-Security',
      alt: 'Cyber-Security',
      rating: 4.5,
    },
     {
      title: 'Data Science',
      description:
        'In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals...',
      imageUrl: DS,
      rating: 4,
      link: '/Data-Science',
      alt: 'Data-Science',
      rating: 4.5,
    },
    {
      title: 'Digital Marketing',
      description:
        'Take a deep dive into the exciting world of marketing management and digital marketing. This...',
      imageUrl: Digital_Marketing,
      rating: 4,
      link: '/Digital-Marketing',
      alt: 'Digital-Marketing',
      rating: 4.5,
    },
    {
      title: 'Embedded System',
      description:
        'embedded systems play a crucial role in modern technology, enabling the functionality...',
      imageUrl: Embedded_System,
      rating: 4,
      link: 'Embedded-Systems',
      alt: 'Embedded-System',
      rating: 4.5,
    },
    {
      title: 'Finance',
      description:
        'With our extensive curriculum that covers Treasury duties, Corporate Finance, Portfolio Management,...',
      imageUrl: Finance,
      rating: 4,
      link: '/Finance',
      alt: 'Finance',
      rating: 4.5,
    },
    {
      title: 'Generative AI',
      description:
        'Begin your transformative journey today with our cutting-edge Generative AI courses and shape...',
      imageUrl: GenerativeAI,
      rating: 4,
      link: '/Generative-Artificial-Intelligence',
      alt: 'Generative-Artificial-Intelligence',
      rating: 4.5,
    },
    {
      title: 'Genetic Engineering',
      description:
        'Genetic Engineering modifies DNA to enhance traits, improve health, and advance medical research in...',
      imageUrl: GE,
      rating: 4,
      link: '/Genetic-Engineering',
      alt: 'Genetic Engineering',
      rating: 4.5,
    },
     {
      title: 'Graphic Design',
      description:
        'Graphic Design combines creativity and technology to craft compelling visuals for branding, marketing, and...',
      imageUrl: GD,
      rating: 4,
      link: '/Graphic-Design',
      alt: 'Graphic Design',
      rating: 4.5,
    },
    {
      title: 'HEV (Hybrid Electric Vechile)',
      description:
        'HEV technology merges electric and combustion engines to improve fuel efficiency and reduce emissions in...',
      imageUrl: HEV,
      rating: 4,
      link: '/Hybrid-Electric-Vehicle',
      alt: 'HEV',
      rating: 4.5,
    },
     {
      title: 'Human Resource',
      description:
        'In-depth study of Human Resource Management (HRM) will be provided in this course. Examine all aspects...',
      imageUrl: Human_Resource,
      rating: 4,
      link: '/Human-Resources',
      alt: 'Human-Resources',
      rating: 4.5,
    },
    {
      title: 'IC Engine',
      description:
        'IC Engine explores internal combustion systems powering vehicles and machinery for performance, efficiency, and...',
      imageUrl: ICE,
      rating: 4,
      link: '/IC-Engine',
      alt: 'IC Engine',
      rating: 4.5,
    },
     {
      title: 'Internet Of Things',
      description:
        'IoT has the potential to revolutionize industries, enhance connectivity, and drive...',
      imageUrl: IOT,
      rating: 4,
      link: '/Internet-Of-Things',
      alt: 'Internet-Of-Things',
      rating: 4.5,
    },
    {
      title: 'Machine Learning With Python',
      description:
        'With our course, take a thorough exploration of the field of machine learning. Explore both supervised and...',
      imageUrl: ML,
      rating: 4,
      link: '/Machine-Learning-With-Python',
      alt: 'Machine-Learning With Python',
      rating: 4.5,
    },
     {
      title: 'Nanoscience & Nanotechnology',
      description:
        'Nanoscience & Nanotechnology study materials at nanoscale for breakthroughs in medicine, energy, and advanced...',
      imageUrl: NSNT,
      rating: 4,
      link: '/Nanoscience-Nanotechnology',
      alt: 'Nanoscience & Nanotechnology',
      rating: 4.5,
    },
       
   
    {
      title: 'Pyschology',
      description:
        'Psychology examines human mind and behavior to understand emotions, cognition, relationships, and improve...',
      imageUrl: Psy,
      rating: 4,
      link: '/Psychology',
      alt: 'Pyschology',
      rating: 4.5,
    },
     {
      title: 'Regulatory Affairs (In Pharma & Healthcare)',
      description:
        'Regulatory Affairs ensures compliance with healthcare laws to bring safe, effective medicines and devices...',
      imageUrl: RA,
      rating: 4,
      link: '/Regulatory-Affairs',
      alt: 'Regulatory Affairs ',
      rating: 4.5,
    },
    {
      title: 'Robotics',
      description:
        'With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types,...',
      imageUrl: Robotics,
      rating: 4,
      link: '/Robotics',
      alt: 'Robotics',
      rating: 4.5,
    },
    {
      title: 'Stock market',
      description:
        'Stock Market teaches investment strategies, trading techniques, and market trends to maximize profits and...',
      imageUrl: SM,
      rating: 4,
      link: '/Stock-Market',
      alt: 'Stock market',
      rating: 4.5,
    },
     {
      title: 'Supply Chain Management',
      description:
        'Supply Chain Management optimizes product flow, logistics, and resources for efficient global trade and...',
      imageUrl: SCM,
      rating: 4,
      link: '/Supply-Chain-management',
      alt: 'Supply Chain Management',
      rating: 4.5,
    },
    {
      title: 'UI/UX Design',
      description:
        'UI/UX Design creates seamless, user-friendly digital interfaces enhancing experiences across web, mobile, and...',
      imageUrl: UIUX,
      rating: 4,
      link: '/UI-UX-Design',
      alt: 'UI/UX Design',
      rating: 4.5,
    },
     {
      title: 'VLSI',
      description:
        'VLSI technology has revolutionized the electronics industry by enabling the development of...',
      imageUrl: VLSI,
      rating: 4,
      link: '/Vlsi-Design',
      alt: 'VLSI',
      rating: 4.5,
    },
    {
      title: 'Web Development',
      description:
        'With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and...',
      imageUrl: WD,
      rating: 4,
      link: '/Web-Development',
      alt: 'Web-Development',
      rating: 4.5,
    },
     
    
    
  ]

  const canonicalUrl = 'https://www.internselite.net/Traineeship-Program'
  return (
    <>
    <style>
      {`.Program_link{
      text-decoration:none !important;
      color: #000;
      }`}
    </style>
    <div>
      <Helmet>
        <title>
          Traineeship Program | InternsElite: Skill Development for the Future
        </title>
        <meta
          name="description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          name="keywords"
          content="traineeship program, online training, certification course, professional courses, skill development, career advancement"
        />
        <meta
          property="og:title"
          content="Traineeship Program | InternsElite: Skill Development for the Future"
        />
        <meta
          property="og:description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Traineeship-Program"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Traineeship Program | InternsElite: Skill Development for the Future"
        />
        <meta
          name="twitter:description"
          content="Enroll in InternsElite’s Traineeship Program to develop in-demand skills and advance your career. Our comprehensive courses include Machine Learning, AI, Web Development, Cyber Security, and more. Gain practical experience, earn certifications, and prepare for future job opportunities with our expert-led training."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      {/* --------------------------Mobile View-------------------------   */}
      <div className="Our_program_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Our_background_color pt-4">
          <div className="text-center Our_program_Main_text py-5">
            <h1 className="display-4 text-white">Traineeship Program</h1>
            <h3 className="text-white fs-6 pt-2">
              Immerse in real-world challenges, gaining practical insights and
              honing your skills for a dynamic career journey.
            </h3>
          </div>
        </div>
      </div>
      <div className="container pt-5 d-sm-block d-md-none">
        <div className="text-center About_Discraption_text">
          <h1 className="display-4">What’s in store for YOU ?</h1>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-12 px-4 Program_card_link" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border Program_link pb-2 shadow Program_mobile_card">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className="px-3">
                    <div className="row">
                      <div className="col-10">
                        <h1 className="pt-2">{course.title}</h1>
                      </div>
                      <div className="col-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>

      {/* --------------------------Desktop View--------------------------- */}
      <div className="Our_program_image d-none d-md-block mt-5">
        <div className="container-fluid Our_background_color py-5">
          <div className="text-center pt-5 Our_program_Main_text mt-5">
            <h1 className="display-4 pt-5 text-white">Traineeship Program</h1>
            <h3 className="text-white fs-4 pb-5 pt-4 mb-5">
              Immerse in real-world challenges, gaining practical insights and
              honing your skills for a dynamic career journey.
            </h3>
          </div>
        </div>
      </div>
      
      {/* ------------------Tab View-------------------- */}
      <div className="container pt-5 d-none d-md-block d-xl-none">
        <div className="Container">
          <div className="text-center About_Discraption_text">
            <h1 className="display-4">What’s in store for YOU ?</h1>
          </div>
        </div>
        <div className="container pb-5">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-md-3 Program_card_link" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border Program_link shadow tab_Program_card pb-1">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                  <div className="px-3 tab_Program_card">
                    <div className="row">
                      <div className="col-md-10">
                        <h1 className="">{course.title}</h1>
                      </div>
                      <div className="col-md-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Our_program
